import {DatabaseCode, toDatabaseCode} from "./database-code";

export type NotificationThreadParticipantValidationMode = DatabaseCode;

const any: NotificationThreadParticipantValidationMode = {
  code: "ANY",
  displayValue: {
    id: "common.entity.notificationtemplatethreadconfig.participantvalidationmode.any",
    defaultMessage: "Any",
  },
};

const originalRecipientsOnly: NotificationThreadParticipantValidationMode = {
  code: "ORIGINAL_RECIPIENTS_ONLY",
  displayValue: {
    id: "common.entity.notificationtemplatethreadconfig.participantvalidationmode.originalrecipientsonly",
    defaultMessage: "Original Recipients Only",
  },
};

const sameDomain: NotificationThreadParticipantValidationMode = {
  code: "SAME_DOMAIN",
  displayValue: {
    id: "common.entity.notificationtemplatethreadconfig.participantvalidationmode.samedomain",
    defaultMessage: "Same Domain",
  },
};

const knownContactsOnly: NotificationThreadParticipantValidationMode = {
  code: "KNOWN_CONTACTS_ONLY",
  displayValue: {
    id: "common.entity.notificationtemplatethreadconfig.participantvalidationmode.knowncontactsonly",
    defaultMessage: "Known Contacts Only",
  },
};

export const notificationThreadParticipantValidationMode = {
  any,
  originalRecipientsOnly,
  sameDomain,
  knownContactsOnly,
};

export const notificationThreadParticipantValidationModes = Object.values(notificationThreadParticipantValidationMode);

export const toNotificationThreadParticipantValidationMode = (code: string): NotificationThreadParticipantValidationMode =>
  toDatabaseCode(code, notificationThreadParticipantValidationModes);

export const toNotificationThreadParticipantValidationModeSafely = (
  code: string | undefined,
): NotificationThreadParticipantValidationMode | undefined =>
  code ? toDatabaseCode(code, notificationThreadParticipantValidationModes) : undefined;
